export default "__VITE_ASSET__BxGkxA1a__"